import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';
import Modal from 'react-modal';
import Button from '../Button';
import config from '../../config/common';
import styles from './styles.module.scss';

// Make sure to bind modal to your appElement (http://reactcommunity.org/react-modal/accessibility/)
Modal.setAppElement('#root');

const ErrorMessage = ({showErrorMessage, message, hideGlobalErrorMessage, currentLocale}) => {
  const contentDirection = (currentLocale === 'he') ? 'rtl' : 'ltr';

  return (
    <Modal
      isOpen={showErrorMessage}
      onRequestClose={hideGlobalErrorMessage}
      className={`${styles.modal} ${styles[contentDirection]}`}
      overlayClassName={styles.overlay}
    >
      <div dir={contentDirection} className={styles.modalContainer}>
        {message}
        <Button
          onClick={hideGlobalErrorMessage}
          className={styles.button}
          label={(
            <FormattedMessage
              id={"common.error.button"}
            />
          )}
        />
      </div>
    </Modal>
  )
};

ErrorMessage.propTypes = {
  showErrorMessage: PropTypes.bool,
  hideGlobalErrorMessage: PropTypes.func,
};

export default ErrorMessage;
